module.exports = __webpack_public_path__ + "img/at.99d0fec3.svg";